class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
            this.setupAddToCartButtons();
            //this.updateTrustvox();
          }
				})
		}
	}

	setupAddToCartButtons() {
		const productItems = this.querySelectorAll('[data-js-product-item]');
		productItems.forEach(item => {
			const addToCartButton = item.querySelector('.quick-add-to-cart');
			if (addToCartButton) {
				// Apply sticky button styling
				addToCartButton.classList.add('button--solid');
				addToCartButton.style.cssText = `
					width: 100%;
					height: 2.875rem;
					padding-inline-end: 1.25rem;
					padding-inline-start: 1.25rem;
					border-color: var(--color-text-main);
					background-color: var(--color-text-main);
					color: var(--color-background-main) !important;
					border-radius: var(--border-radius-buttons);
					font-weight: var(--font-weight-buttons);
					transition: all 100ms linear;
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: center;
					text-decoration: none;
					border: none;
					font-size: inherit;
				`;

			}
		});
	}





	/**	updateTrustvox() {
			if (typeof window.updateTrustvoxGlobal === 'function') {
				window.updateTrustvoxGlobal();
			}
		}
		**/
}
customElements.define('cart-recommendations', CartRecommendations);